// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/deployer/v1/value.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Any, Duration, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * Represents a generic holder for different value types for metrics and
 * parameters.
 *
 * @generated from message ai.h2o.deploy.Value
 */
export const Value = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.Value",
  () => [
    { no: 9, name: "double_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, oneof: "value" },
    { no: 10, name: "string_value", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "value" },
    { no: 11, name: "int64_value", kind: "scalar", T: 3 /* ScalarType.INT64 */, oneof: "value" },
    { no: 12, name: "bool_value", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "value" },
    { no: 13, name: "json_value", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "value" },
    { no: 14, name: "timestamp_value", kind: "message", T: Timestamp, oneof: "value" },
    { no: 15, name: "duration_value", kind: "message", T: Duration, oneof: "value" },
    { no: 16, name: "proto_value", kind: "message", T: Any, oneof: "value" },
    { no: 17, name: "id_value", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "value" },
  ],
);

